// extracted by mini-css-extract-plugin
export var card = "post-card-module--card--197gJ";
export var category = "post-card-module--category--ikuMV";
export var desc = "post-card-module--desc--Iot1o";
export var details = "post-card-module--details--i94DY";
export var info = "post-card-module--info--HTx7h";
export var poster = "post-card-module--poster--r4nA3";
export var title = "post-card-module--title--nDOMG";